<template>
  <fragment>
    <v-layout justify-center>
      <v-flex
        md5
      >
        <v-select
          v-model="form.values.pet"
          :items="petList"
          :label="$t('messages.choosePet')"
          :no-data-text="$t('messages.noDataAvailable')"
          :error-messages="getRequiredErrors(form.errors.pet)"
          item-text="name"
          item-value="id"
        />
      </v-flex>
      <v-btn
        fab
        small
        color="secondary"
        class="add-button"
        @click="openAddDialog"
      >
        <v-icon>add</v-icon>
      </v-btn>
    </v-layout>
    <PetDialog
      v-model="dialog"
      type="new"
    />
  </fragment>
</template>

<script>
import { Fragment } from 'vue-fragment'
import PetDialog from '../../pets/PetDialog'

export default {
  name: 'PetSelect',
  components: {
    PetDialog,
    Fragment,
  },
  props: {
    form: {
      type: Object,
      required: true,
    },
    petList: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
    }
  },
  methods: {
    openAddDialog() {
      this.dialog = true
    },
    getRequiredErrors(values = {}) {
      const errors = []
      if (values.required) errors.push(this.$t('validates.requiredField'))
      return errors
    },
  },
}
</script>

<style scoped>

</style>
